import { ExpertsApplyModel } from "../../../domain/ExpertsApplyFormModel";
import { DialogType, EntityDialog } from "../../types";
import { AddNoteDialog } from "./dialogs/AddNoteDialog";
import { SendPublicMessageDialog } from "./dialogs/SendPublicMessageDialog";
import { InternalMessageDialog } from "../../dialogs/AddInternalMessage";
import { UpdatedDialog } from "../../dialogs/UpdatedDialog";
import { Activity } from "@ofqual/portal-activity-feed";
import { ExpertiseAddedDialog } from "../../dialogs/ExpertiseAddedDialog";
type RenderDialogProps = {
  focusedEntity: EntityDialog | null;
  onClose: () => void;
  specialist: ExpertsApplyModel;
};

export const RenderDialog: React.FC<RenderDialogProps> = ({
  focusedEntity,
  onClose,
  specialist
}) => {
  if (!focusedEntity) return null;

  const { dialogType } = focusedEntity;
  const focusedActivity = focusedEntity.focusedActivity as Activity;

  switch (dialogType) {
    case DialogType.SendPublicMessage:
      return (
        <SendPublicMessageDialog
          onClose={onClose}
          specialist={specialist}
          activity={focusedActivity}
        />
      );
    case DialogType.AddInternalMessage:
      return <InternalMessageDialog onClose={onClose} resource={specialist} />;
    case DialogType.AddCaseNote:
      return <AddNoteDialog onClose={onClose} resource={specialist} />;
    case DialogType.SpecialistSmsChange:
      return <UpdatedDialog activity={focusedActivity} onClose={onClose} />;
    case DialogType.AddExpertiseActivity:
      return <ExpertiseAddedDialog activity={focusedActivity} onClose={onClose} />;
    default:
      return null;
  }
};
